<template>
  <div class="stage-switch" :class="{ open: switchOpen}">
    <div v-if="$parent.isSwitchOpen">
      <el-button class="close" icon="el-icon-arrow-down" circle @click="switchClose"></el-button>
    </div>
    <el-checkbox-group v-model="checkedStages" :min="1" style="padding: 0 8px">
      <el-checkbox v-for="(stage, index) in stageSwitch" :id="stage.name" :class="stage.name" :label="stage.name" :key="stage" style="margin: 0;" @change="handleCheckedStageChange(index)" v-if="stage.stage_icon">
        <img :src="stage.stage_icon" alt="">
      </el-checkbox>

      <el-checkbox v-for="(stage, index) in stageSwitch" :id="stage.name" :class="stage.name" class="checkbox-margin-left" :label="stage.name" :key="stage" style="margin: 0 4px;" @change="handleCheckedStageChange(index)" v-if="!stage.stage_icon">
        {{ stage.name }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'StageSwitch',
  props: {
    stageSwitch: null,
    checkedStages: null,
    switchOpen: false
  },
  methods: {
    handleCheckedStageChange (index) {
      if (this.$parent.stage.stage[index].preview) {
        this.$parent.stage.stage[index].preview = false
        document.getElementById(this.stageSwitch[index].name).style.opacity = 0.4
      } else {
        this.$parent.stage.stage[index].preview = true
        document.getElementById(this.stageSwitch[index].name).style.opacity = 1
      }
    },
    classNameTrim: function (className) {
      let stageName = className.replace(/\s+/g, '-')
      return stageName
    },
    switchClose () {
      this.$parent.checkedStages = this.checkedStages
      this.$parent.isSwitchOpen = false
    }
  },
  updated () {
    for (let index = 0; index < this.stageSwitch.length; index++) {
      if (this.stageSwitch[index].preview) {
        document.getElementById(this.stageSwitch[index].name).style.opacity = 1
      } else {
        document.getElementById(this.stageSwitch[index].name).style.opacity = 0.4
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/css/components/parts/StageSwitch";
</style>



// WEBPACK FOOTER //
// src/components/parts/StageSwitch.vue